<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item >
            <el-select v-model="query.brandid" clearable filterable placeholder="按品牌" style="width:100%;" @change="queryselect=true">
              <el-option label="不选品牌" value="0"></el-option>
              <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  <span style="float: left">{{item.name}}</span>
      			  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:10%">
            <el-select v-model="query.warehouse" clearable placeholder="按仓库" style="width:100%;" @change="resetSearchParams">
              <el-option label="全部仓库" value="0"></el-option>
              <el-option v-for="(item,index) in warehouselists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <!--  -->
          <el-form-item v-if="goodsLocationStatus">
            <el-cascader
              :props="{ label: 'full_code', value: 'id', children: 'children' }"
              v-model="storage_location"
              :options="locationList"
              placeholder="请选择位置"
              clearable
              >
            </el-cascader>
          </el-form-item>
          <el-form-item ref="query" :model="query" v-if="goodsLocationStatus">
            <el-input placeholder="请输入货位" v-model="query.storage_location_keyword" clearable @keyup.enter.native="getList" @change="queryselect=true"></el-input>
          </el-form-item>
          <!--  -->
          <el-form-item>
            <el-select v-model="query.type" clearable placeholder="按类型" style="width:100px;" @change="queryselect=true">
              <el-option label="全部类型" value=""></el-option>
              <el-option v-for="(item,index) in typelist" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:22%">
            <el-date-picker style="width:100%"
              v-model="query.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd" @change="queryselect=true" :unlink-panels="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item ref="query" :model="query">
            <el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" style="width:150px;" @blur="queryselect=true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
            <el-button type="primary" icon="el-icon-search" @click="outputinfos">导出</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading">
          <el-table-column prop="documents" label="单据编号" width="90"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="brandname" label="品牌" width="110" align="center"></el-table-column>
          <el-table-column prop="number" label="编号" width="100" align="center"></el-table-column>
          <el-table-column prop="spec" label="规格" width="90" align="center"></el-table-column>
          <el-table-column prop="num" label="数量" width="80" align="center"></el-table-column>
          <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
          <el-table-column prop="inventory" label="剩余量" width="80" align="center"></el-table-column>
          <el-table-column prop="warename" label="仓库" width="110" align="center"></el-table-column>
          <el-table-column label="货位" width="225" align="center" v-if="goodsLocationStatus">
              <template slot-scope="scope">
                <div class="">
                    <div class="cz-product-inventorys-value">{{scope.row.storage_location_code}}</div>
                </div>
              </template>
          </el-table-column>
          <el-table-column prop="inputtime" label="入库日期" width="120" align="center"></el-table-column>
          <el-table-column prop="type" label="类型" width="70" align="center">
	          <template slot-scope="scope">
	            <el-tag v-if="scope.row.type=='进货'">{{scope.row.type}}</el-tag>
	            <el-tag type="danger" v-if="scope.row.type=='赠送'">{{scope.row.type}}</el-tag>
	            <el-tag type="warning" v-if="scope.row.type=='退货'">{{scope.row.type}}</el-tag>
	            <el-tag type="danger" v-if="scope.row.type=='盘点'">{{scope.row.type}}</el-tag>
	            <el-tag type="success" v-if="scope.row.type=='调拨'">{{scope.row.type}}</el-tag>
	          </template>
          </el-table-column>
          <el-table-column v-if="batchStatus" label="操作" width="80" align="center">
              <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="view(scope.row)">查看明细</el-button>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="query.p"
            :page-sizes="[10, 20, 50]"
            :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        </div>

        <!-- 查看明细弹窗开始 -->
        <el-dialog title="查看明细信息" :visible.sync="detailDialogVisible" width="70%" @close="resetDetailData">
            <el-table :data="detailData" border>
                <el-table-column prop="warehouse_name" label="入库仓库" align="center"></el-table-column>
                <el-table-column prop="full_code" label="入库货位" align="center"></el-table-column>
                <el-table-column prop="numbers" label="入库数量" align="center"></el-table-column>
                <el-table-column v-if="batchStatus" prop="batch_sn" label="批次号" align="center" width="180"></el-table-column>
                <el-table-column prop="start_date" label="生产日期" align="center">
                  <template slot-scope="scope">
                  <span v-if="scope.row.start_date == '0' || !scope.row.start_date">/</span>
                  <span v-else>{{ scope.row.start_date}}</span>
                </template>
                </el-table-column>
                <el-table-column v-if="batchStatus" prop="realvalidity" label="有效期" width="180" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.realvalidity }} {{ validityunitTemp[scope.row.validityunit] }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="batchStatus" prop="end_date" label="到期日期" align="center">
                  <template slot-scope="scope">
                  <span v-if="scope.row.end_date == '0' || !scope.row.end_date">/</span>
                  <span v-else>{{ scope.row.end_date}}</span>
                </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 查看明细弹窗结束 -->
        
        <!------------------------ 导出信息确认 ------------------------------->
        <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="95%" top="5vh">
      	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
      	  <div id="outputorder">
	      	  <el-table :data="outlists" border v-loading="outlistsLoading">
	      	  	  <el-table-column prop="inputtime" label="时间"></el-table-column>
	          	  <el-table-column prop="documents" label="单号编号"></el-table-column>
	          	  <el-table-column prop="customername" label="客户名称" align="center" v-if="query.type=='退货'"></el-table-column>
	          	  <el-table-column prop="brandname" label="品牌" align="center"></el-table-column>
	          	  <el-table-column prop="number" label="商品编号" align="center"></el-table-column>
	          	  <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
	          	  <el-table-column prop="spec" label="规格" align="center"></el-table-column>
	          	  <el-table-column prop="num" label="数量" align="center"></el-table-column>
	          	  <el-table-column prop="unit" label="单位" align="center"></el-table-column>
	          	  <el-table-column prop="buy" label="单价"></el-table-column>
	          	  <el-table-column prop="total" label="合计"></el-table-column>
	          	  <el-table-column prop="type" label="类型"></el-table-column>
	          	  <el-table-column prop="warename" label="仓库名称"></el-table-column>
                <el-table-column label="货位" prop="storage_location_code" width="150" align="center" v-if="goodsLocationStatus"></el-table-column>
	          	  <el-table-column prop="note" label="备注"></el-table-column>
	      	  </el-table>
      	  </div>
      	  <div slot="footer" class="dialog-footer">
	          <el-button size="medium" @click="outputDialog=false">取 消</el-button>
	          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
	      </div>	                
        </el-dialog>
        
        
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      lists:[],
      listLoading:false,
      query:{
        act:'storage',
        token:this.$cookies.get('token'),
        brandid:'',
        type:'',
        date:[],
        warehouse:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1,
        storage_location:'',
        storage_location_keyword:''
      },
      total_rows: 0,
      brandlists:[],
      warehouselists:[],
      typelist:[{
        name:'进货'
      },{
        name:'调拨'
      },{
        name:'退货'
      },{
      	name:'盘点'
      }],
      
      queryselect:false,
      outlistsLoading:false,
      outputDialog:false,
      outlists:[],
      goodsLocationStatus:false,
      locationList:[],
      storage_location:[],
      goodsLocationStatus:false,
      detailDialogVisible: false, // 控制查看明细弹窗的显示状态
      detailData: [], // 存储查看明细的表格数据
      validityunitTemp: { // 存储有效期单位
        1: '天',
        2: '月',
        3: '年'
      },
      batchStatus: false
    }
  },

  mounted(){
    this.getWarehouse();
    this.getBrand();
    this.getList();
    this.checkLocationStatus()
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
  },
  methods:{

    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    //获取品牌
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取仓库
    getWarehouse(){
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.warehouselists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    //信息列表
    getList(){
    
      if(this.queryselect==true) {
		  this.query.p=1;
		  this.query.rollpage=10;	    	
      }
      if(Array.isArray(this.storage_location)&&this.storage_location.length>0){
        const last_item = this.storage_location[this.storage_location.length-1]
        this.query.storage_location=last_item
      }else{
        this.query.storage_location=''
      }
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
          if(this.queryselect==true) this.queryselect=false;
          console.log(this.lists)
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
          if(this.queryselect==true) this.queryselect=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    //导出商品信息
    outputinfos() {
    	this.outlistsLoading=true;
    	this.outputDialog=true;
        var resource = this.$resource(this.GLOBAL.exportUrl+'Stat/index');
        resource.query({
          act:'getstoragelogdata',
          ...this.query,
          token:this.$cookies.get('token'),
          isexport:1
        }).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.outlistsLoading=false;
        }else{
            this.outlists = JSON.parse(Base64.decode(res.data.Data))
            this.outlistsLoading=false;
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.outlistsLoading=false;
        });
    },
    
    /** 确认导出订单信息 **/
    sureoutput() {
      require.ensure([], () => {
        var name = '';
        if (this.query.type == '') name = '出库记录列表';
        if (this.query.type == '进货') name = '进货记录列表';
        if (this.query.type == '调拨') name = '调拨记录列表';
        if (this.query.type == '退货') name = '退货记录列表';
        if (this.query.type == '盘点') name = '盘点记录列表';

        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['出库日期', '单据编号', '客户名称', '品牌', '商品编号', '商品名称', '规格', '数量', '单位', '单价', '总价', '销售员', '类型', '支付方式', '仓库名称', '备注'];
        var filterVal = ['inputtime', 'documents', 'customername', 'brandname', 'number', 'name', 'spec', 'num', 'unit', 'buy', 'total', 'clerkname', 'type', 'account', 'warename', 'desc'];
        var list = this.outlists;

        if (this.goodsLocationStatus) {
          // 在 "仓库名称" 后面插入 "货位"
          const warenameIndex = tHeader.indexOf('仓库名称');
          tHeader.splice(warenameIndex + 1, 0, "货位");
          filterVal.splice(warenameIndex + 1, 0, "storage_location_code");
        }

        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, name);
        this.outputDialog = false;
      });
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},
     checkLocationStatus(){
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus")||''
      if(goodsLocationStatus == "true"){
        this.goodsLocationStatus=true
      }else{
        this.goodsLocationStatus=false
      }      
    },
    resetSearchParams(){
      this.queryselect=true
      this.storage_location=[]
      this.query.storage_location=''
      if(this.goodsLocationStatus){
        this.locationDropdownList()
      }
    },
    locationDropdownList(){
      const address_url = this.GLOBAL.domain+"StorageLocation/cascade_tree"
      const send_data = {warehouse_id:this.query.warehouse,token:this.$cookies.get('token')}
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if(res.data.Result>0){
            this.locationList = []
            this.$message.error(res.data.Message);
        }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            this.locationList = result
            console.log(result)
        }
      }).catch((res) => {
          this.locationList = []
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    // 查看明细方法
    view(row) {
      this.detailDialogVisible = true; // 打开对话框
      const params = {
        act: 'see_store_list',
        token: this.$cookies.get('token'),
        id: row.id
      };
      const resource = this.$resource(this.GLOBAL.domain + 'Stat/index');
      resource.query(params).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result === '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.detailData = JSON.parse(Base64.decode(res.data.Data)); // 填充表格数据
          console.log("🚀 ~ resource.query ~ this.detailData:", this.detailData)
          
        }
      }).catch((err) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    // 重置查看明细数据的方法
    resetDetailData() {
      this.detailData = []; // 关闭弹窗时重置表格数据
    },
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Storage.vue